export default __webpack_public_path__ + "static/media/invozone.89314050.jpg";